import React, { FC } from 'react';
import { calculateArticleLink } from '../../../../shared/helpers';
import TimeToRead from '../../../../shared/TimeToRead';
import { ArticlePreview } from '../../../../../../shared/types';
import { Image } from '../../../../shared/Image';

import './index.scss';

const responsiveImageData = {
  sizes: [
    '(min-width: 1160px) 300px',
    '(min-width: 900px) 340px',
    '(min-width: 600px) 410px',
    '(min-width: 480px) 560px',
    '440px',
  ],
  srcSet: [300, 340, 410, 560, 440, 700], // 700 used for retina
};

const RelatedGuidesItem: FC<{ article: ArticlePreview }> = ({ article }) => {
  const link = calculateArticleLink(article);

  return (
    <div className="related-guides-item">
      <a href={link} className="media-wrapper">
        <Image
          srcset={[article.mainImage.image]}
          alt={article.mainImage.alt}
          responsiveImageData={responsiveImageData}
          lazyLoad
        />
      </a>
      <a href={link} className="heading">
        {article.title}
      </a>
      {article.timeToRead && (
        <div className="time-to-read">
          <TimeToRead timeToRead={article.timeToRead} />
        </div>
      )}
    </div>
  );
};

export default RelatedGuidesItem;
